import { Event as TEvent } from "../../../../Global/Base/Events";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../Global/Base/Rights/RightTypes";
import { EnumType } from "../../../../OW.Remoting/Remoting/DataTypes/Enums";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { ComboBox } from "./ComboBox";
/**
 * Třída představuje sekci vodorovná osa v ChartSettingsPanel => ChartSettingsContentBuilder
 */
export class ChartHorizontalAxis {
    /** událost změny xAxisAttr */
    public xAxisAttrChanged: TEvent<string, void> = new TEvent<string, void>();
    private _element: HTMLElement;
    private _xAxisAttr: string;
    private _comboBoxData: EnumType;
    private _comboBox: ComboBox;
    private _cssClass: string = "chart-horizontal-axis";

    public get element(): HTMLElement {
        return this._element;
    }

    constructor(xAxisAttr: string, comboBoxData: EnumType) {
        this._xAxisAttr = xAxisAttr;
        this._comboBoxData = comboBoxData;
        this._element = createElement({ classes: [this._cssClass] });
        this._initialize();
    }

    private _initialize(): void {
        const horizontalAxisText = createElement({ classes: [this._cssClass + "__header"] });
        Localization.addLocTxtData(horizontalAxisText, "GUI-676796"); // vodorovná osa
        const elementComboBox = createElement();

        this._comboBox = new ComboBox({ element: elementComboBox, originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });
        this._comboBox.setData(this._comboBoxData).then(() => {
            if (this._xAxisAttr) {
                this._comboBox.setDisplayedValueByName(this._xAxisAttr);
            }
        });
        this._comboBox.valueChanged.add(() => {
            this.xAxisAttrChanged.trigger(this._comboBox.getSelectedItemValue(), null);
        });

        this._element.appendChild(horizontalAxisText);
        this._element.appendChild(elementComboBox);
    }

    public dispose(): void {
        this._comboBox.dispose();
    }
}
